import React from 'react';
import { useSelector } from 'react-redux';

import HeaderStatistics from '../../Components/Statistics/HeaderStatistics/HeaderStatistics';
import { StatisticsStudent } from '../../Components/Statistics/StatisticsStudent/StatisticsStudent';
import { StatisticsTeacher } from '../../Components/Statistics/StatisticsTeacher/StatisticsTeacher';
import { selectIsAutocompleteFocused, selectSelectedRole } from '../../redux/slices/statistics/statisticsSlice';

import './style.scss';
import { StatisticsAll } from '../../Components/Statistics/StatisticsAll/StatisticsAll';

const Statistics = () => {
  const isFocused = useSelector(selectIsAutocompleteFocused);
  const currentRole = useSelector(selectSelectedRole);

  return (
    <div className="statistics-page container">
      <div className={`blur-search ${isFocused ? 'blurr' : ''}`}></div>
      <StatisticsAll />
      <HeaderStatistics hidden={false} />

      {currentRole && currentRole === 'Teacher' && <StatisticsTeacher />}

      {currentRole && currentRole === 'Student' && <StatisticsStudent />}
    </div>
  );
};

export default Statistics;
